import React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { getSentinelClipsWithQuerry } from "./ClipsUtilities/getSentinelClipsWithQuerry";
import { createEmptyPrecisionRecallData } from "./ClipsUtilities/totalUpPrecisionRecallData";
import { updateClipsSearchParams } from "./ClipsUtilities/clipsUrlParams";
import { useClipsStore } from "./ClipsStore/clipsStore";

export const ApplyFiltersButtonSentinel = ({
  setSentinelData,
  setPageLoadingSentinel,
  setSelectedRowSentinel,
  setPrecisionRecallDataSentinel,
  setVideoURLSentinel,
  setVideoClipLoadingSentinel,
  setClipsIndexOrderSentinel,
  selectedRowSentinel,
  setNoDataToDisplaySentinel,
  setSiteOptionsSentinel,
  setLoadingSitesSentinel,
  userFiltersSentinel,
  setFetchingFilteredDataSentinel,
  setPageSentinel,
  onSentinelFiltersApply,
  setLoadingAdditionalData,
  setFiltersApplied,
  navigate,
  setSearchParams,
}: {
  setSentinelData: any;
  setPageLoadingSentinel: Dispatcher<boolean>;
  setSelectedRowSentinel: any;
  setPrecisionRecallDataSentinel: any;
  setVideoURLSentinel: any;
  setVideoClipLoadingSentinel: Dispatcher<boolean>;
  setClipsIndexOrderSentinel: any;
  selectedRowSentinel: any;
  setNoDataToDisplaySentinel: Dispatcher<boolean>;
  setSiteOptionsSentinel: any;
  setLoadingSitesSentinel: any;
  userFiltersSentinel: any;
  setFetchingFilteredDataSentinel: Dispatcher<boolean>;
  setPageSentinel: any;
  onSentinelFiltersApply?: () => void;
  setLoadingAdditionalData: Dispatcher<boolean>;
  setFiltersApplied: Dispatcher<boolean>;
  navigate: NavigateFunction;
  setSearchParams?: (params: URLSearchParams) => void;
}) => {
  const options = ["Apply Filters", "Download Report"];

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [option, setOption] = React.useState(options[0]);

  const {
    downloadURLSentinel,
    fetchingDownloadURLSentinel,
    getDownloadURLSentinel,
  } = useClipsStore();

  const handleRefreshReport = () => {
    getDownloadURLSentinel(navigate, userFiltersSentinel, true);
  };

  const handleClick = () => {
    if (option === "Apply Filters") {
      onSentinelFiltersApply?.();
      setPageSentinel(0);
      setFiltersApplied(true);
      setLoadingAdditionalData(true);
      setSentinelData([]);
      setNoDataToDisplaySentinel(true);
      setSelectedRowSentinel({});
      setPrecisionRecallDataSentinel(createEmptyPrecisionRecallData());
      setFetchingFilteredDataSentinel(true);
      localStorage.setItem("last_file_id_sentinal", "");
      localStorage.setItem("last_timestamp_sentinal", "");
      getSentinelClipsWithQuerry(
        setSentinelData,
        setPageLoadingSentinel,
        setSelectedRowSentinel,
        setPrecisionRecallDataSentinel,
        setVideoURLSentinel,
        setVideoClipLoadingSentinel,
        setClipsIndexOrderSentinel,
        selectedRowSentinel,
        setNoDataToDisplaySentinel,
        setSiteOptionsSentinel,
        setLoadingSitesSentinel,
        userFiltersSentinel,
        setFetchingFilteredDataSentinel,
        setPageSentinel,
        "",
        "",
        false,
        setLoadingAdditionalData,
        navigate
      );
      if (setSearchParams) {
        updateClipsSearchParams(
          setSearchParams,
          "sentinel",
          userFiltersSentinel
        );
      }
    }
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setOption(options[index]);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  return (
    <div className="z-10">
      <React.Fragment>
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="Site Group Actions"
          disabled={false}
          color="warning"
        >
          {option === "Apply Filters" ? (
            <Button
              onClick={handleClick}
              disabled={false}
              sx={{
                backgroundColor: "#FF8400",
                "&:hover": { backgroundColor: "#E67300" },
                width: "140px",
              }}
            >
              {option}
            </Button>
          ) : (
            <Button
              onClick={() => {}}
              component="a"
              href={downloadURLSentinel}
              download
              disabled={!downloadURLSentinel}
              sx={{
                color: "white",
                backgroundColor: "#FF8400",
                "&:hover": {
                  backgroundColor: "#E67300",
                  color: "white",
                },
                width: "178px",
                textDecoration: "none",
              }}
            >
              {fetchingDownloadURLSentinel
                ? "Fetching Report..."
                : "Download Report"}
            </Button>
          )}
          {option === "Download Report" && (
            <Tooltip title="Regenerate the report with the latest clips">
              <Button
                size="small"
                aria-label="refresh report"
                disabled={fetchingDownloadURLSentinel}
                sx={{
                  backgroundColor: "#FF8400",
                  "&:hover": { backgroundColor: "#E67300" },
                }}
                onClick={handleRefreshReport}
              >
                <RefreshIcon />
              </Button>
            </Tooltip>
          )}
          <Button
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select group action"
            aria-haspopup="menu"
            sx={{
              backgroundColor: "#FF8400",
              "&:hover": { backgroundColor: "#E67300" },
            }}
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    className="absolute"
                    id="split-button-menu"
                    autoFocusItem
                  >
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        selected={index === options.indexOf(option)}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </React.Fragment>
    </div>
  );
};
